import React from 'react';

import * as PanelTypes from '../../../state/views/panel/types';
import {useConfigXBounds} from '../../Panel/hooks/hooks';
import {usePanelSharedProps} from '../../Panel/hooks/usePanelSharedProps';
import {SharedPanelStateContextProvider} from '../../Panel/SharedPanelStateContext';
import {default as PanelRunsLinePlot} from '../../PanelRunsLinePlot/ComponentWrapper';
import {RunsLinePlotConfig} from '../../PanelRunsLinePlot/types';

export type LinePlotPanelEditorPanelProps = {
  panelRef: PanelTypes.Ref;
};

export const LinePlotPanelEditorWrapper = ({
  panelRef,
}: LinePlotPanelEditorPanelProps) => {
  const props = usePanelSharedProps(panelRef);
  const configXBounds = useConfigXBounds(panelRef);

  return (
    <SharedPanelStateContextProvider config={configXBounds}>
      <PanelRunsLinePlot
        {...props}
        configMode={true}
        showDrawer={true}
        currentHeight={0}
        dimensions={undefined as any}
        pageQuery={props.pageQuery}
        config={props.config as RunsLinePlotConfig}
        updateConfig={
          props.updateConfig as (config: RunsLinePlotConfig) => void
        }
      />
    </SharedPanelStateContextProvider>
  );
};
